import { render, staticRenderFns } from "./associatedTenant.vue?vue&type=template&id=10546f70&scoped=true&"
import script from "./associatedTenant.vue?vue&type=script&lang=js&"
export * from "./associatedTenant.vue?vue&type=script&lang=js&"
import style0 from "./associatedTenant.vue?vue&type=style&index=0&id=10546f70&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10546f70",
  null
  
)

export default component.exports